import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ProtocolAnswerHttpEditRequestModel } from '../httpQueue/protocolAnswer/types';
import { ProtocolAnswerUpdateOutDto } from 'shared/dtos/out/protocolAnswer';

export class ProtocolAnswerEditor {
  constructor(
    private addRequest: (
      request: ProtocolAnswerHttpEditRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    inspectionId: string,
    protocolItemId: string,
    protocolAnswerId: string,
    protocolAnswerOutDto: ProtocolAnswerUpdateOutDto,
    uniqueId: string,
    projectId: string
  ): Promise<void> {
    debugLog(
      'ProtocolAnswerEditor',
      inspectionId,
      protocolItemId,
      protocolAnswerId,
      protocolAnswerOutDto
    );
    const request: ProtocolAnswerHttpEditRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        inspectionId,
        protocolItemId,
        protocolAnswerId,
        protocolAnswerOutDto,
        uniqueId,
        projectId,
      },
      entityType: HttpRequestModelType.protocolAnswer,
      status: HttpRequestStatus.NEW,
      url: `/project/${projectId}/inspection/${inspectionId}/protocolItem/${protocolItemId}/answer/${protocolAnswerId}`,
    };

    await this.addRequest(request);
  }
}

export const protocolAnswerEditor = new ProtocolAnswerEditor(addRequest);
